<template>
    <div :style=" isMobile ? 'width: 50%' : 'width: 650px'">
      <v-card elevation="4" color="white">
          <v-card-title class="d-flex justify-space-between align-center">
    <div class="d-flex align-center">
      <v-icon large left color="primary">mdi-filter</v-icon>
      <span class="text-h6 font-weight-light mr-3">Filter</span>
    </div>
    <v-icon size="20" color="red" class="clickable" @click="closeFilter">mdi-close</v-icon>
  </v-card-title>
        <v-row>
          <v-col>
            <v-container>
              <v-select
                v-model="selectedTypes"
                :items="conTypes"
                item-value="type_name"
                item-title="type_name"
                placeholder="Select to filter"
                label="Contact Types"
                @update:model-value="handleSelectTypes"
                multiple
                variant="underlined"
                style="min-width: 120px; cursor: pointer;"
                color="success"
                clearable
              >
                <template v-slot:item="{ item, props }">
                  <div
                    v-bind="props"
                    :style="{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '5px 8px',
                      cursor : 'pointer',
                      backgroundColor: selectedTypes.includes(item.value)
                        ? '#DDEEFF'
                        : 'transparent',
                    }"
                  >
                   
                    <v-avatar
                     rounded="lg"
                     size="x-small"
                    :color="item.raw.color">
                    
                      <v-btn icon size="x-small" variant="text" >
                          <v-icon>mdi-account-outline</v-icon>
                        </v-btn>
                      </v-avatar>
                       
                    <span :style="{ textAlign: 'left', flex: 1 , padding: '3px'}">
                      {{item.value}}
                    </span>
                  </div>
                </template>
  
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index === selectedTypes.length - 1"
                    label
                    small
                    closable
                    color="indigo-darken-1"
                    class="rounded-md"
                    @click:close="removeTypeSelectedChip(item.value)"
                  >
                    <span>{{ item.value }}</span>
                    <template v-slot:close>
                      <v-icon color="red" size="15">mdi-close</v-icon>
                    </template>
                  </v-chip>
  
                  <span
                    v-if="index === selectedTypes.length - 2"
                    class="grey--text caption"
                  >
                    <v-chip label size="30" color="indigo-darken-1"
                      >+{{ selectedTypes.length - 1 }}</v-chip
                    >
                  </span>
                </template>
              </v-select>
            </v-container>
          </v-col>
          <v-col>
            <v-container>
              <v-select
                v-model="selectedTags"
                :items="conTags"
                item-value="tag_name"
                item-title="tag_name"
                placeholder="Select to filter"
                label="Contact Tags"
                @update:model-value="handleSelectTags"
                multiple
                variant="underlined"
                style="min-width: 120px"
                clearable
                color="success" 
              >
                <template v-slot:item="{ item, index, props }">
                  <div
                    v-bind="props"
                    :style="{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '5px 8px',
                      cursor : 'pointer',
                      backgroundColor: selectedTags.includes(item.value)
                        ? '#DDEEFF'
                        : 'transparent',
                    }"
                  >
                    <v-icon class="mr-2" size="15" :color="item.raw.tag_color">
                      mdi-{{ item.raw.tag_icon }}
                    </v-icon>
                    <span :style="{ textAlign: 'left', flex: 1 }">
                      {{ item.raw.tag_name }}
                    </span>
                  </div>
                </template>
  
                <template v-slot:selection="{ item, index }">
                  <v-chip
                    v-if="index === selectedTags.length - 1"
                    label
                    small
                    closable
                    color="indigo-darken-1"
                    class="rounded-md"
                    @click:close="removeTagSelectedChip(item.value)"
                  >
                    <span>{{ item.raw.tag_name }}</span>
                    <template v-slot:close>
                      <v-icon color="red" size="15">mdi-close</v-icon>
                    </template>
                  </v-chip>
                  <span
                    v-if="index === selectedTags.length - 2"
                    class="grey--text caption"
                  >
                    <v-chip label size="30" color="indigo-darken-1"
                      >+{{ selectedTags.length - 1 }}</v-chip
                    >
                  </span>
                </template>
              </v-select>
            </v-container>
          </v-col>
          <v-col>
            <v-container>
              <v-select
                v-model="conversationTagFilter"
                :items="conversationTags"
                item-title="tag_name"
                item-value="tag_id"
                placeholder="Select to filter"
                label="Conversation Tags"
                multiple
                variant="underlined"
                style="min-width: 120px"
                clearable
                color="success"
              >
                <!-- Dropdown item (Same UI as Contact Tags) -->
                <template v-slot:item="{ item, props }">
                  <div
                    v-bind="props"
                    :style="{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '5px 8px',
                      cursor: 'pointer',
                      backgroundColor: conversationTagFilter.includes(item.value)
                        ? '#DDEEFF'
                        : 'transparent',
                    }"
                  >
                    <v-icon class="mr-2" size="15" :color="item.raw.tag_color">
                      mdi-{{ item.raw.tag_icon }}
                    </v-icon>

                    <span :style="{ textAlign: 'left', flex: 1 }">
                      {{ item.raw.tag_name }}
                    </span>
                  </div>
                </template>

                <!-- Selected Chips (Same behaviour) -->
                <template v-slot:selection="{ item, index }">
                  <!-- Last selected chip -->
                  <v-chip
                    v-if="index === conversationTagFilter.length - 1"
                    label
                    small
                    closable
                    color="indigo-darken-1"
                    class="rounded-md"
                    @click:close="removeConversationTagChip(item.value)"
                  >
                    <span>{{ item.raw.tag_name }}</span>

                    <template v-slot:close>
                      <v-icon color="red" size="15">mdi-close</v-icon>
                    </template>
                  </v-chip>

                  <!-- +Count Chip -->
                  <span
                    v-if="index === conversationTagFilter.length - 2"
                    class="grey--text caption"
                  >
                    <v-chip label size="30" color="indigo-darken-1">
                      +{{ conversationTagFilter.length - 1 }}
                    </v-chip>
                  </span>
                </template>
              </v-select>
            </v-container>
          </v-col>


          <!-- <v-col v-if="isODEnabled">
            <v-container>
              <v-select
                v-model="selectedODlist"
                label="Get from Open Dental"
                :items="odList"
                item-value="name"
                item-title="name"
                @update:model-value="handleSelectODlist"
                variant="underlined"
                style="min-width: 120px"
                clearable
                color="success"
                :disabled="selectedTypes.length!==0 || selectedTags.length!=0"
              >
              <template v-slot:item="{ item, props }">
                  <div
                    v-bind="props"
                    :style="{
                      display: 'flex',
                      alignItems: 'center',
                      padding: '5px 8px',
                      cursor : 'pointer',
                    }"
                  >
                    <v-icon class="mr-2" size="15" :color="item.raw.color">
                      mdi-{{ item.raw.icon }}
                    </v-icon>
                    <span :style="{ textAlign: 'left', flex: 1 }">
                      {{ item.value }}
                    </span>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <v-icon  class="mr-2" size="15" :color="item.raw.color">
                    mdi-{{ item.raw.icon }}
                  </v-icon>
                  <span>{{ item.value }}</span>
                </template>
              </v-select>
            </v-container>
          </v-col> -->
        </v-row>
      </v-card>
    </div>
    
  </template>
  
  <script>
  import { mapGetters } from "vuex";
  export default {
    name: "AllFilter",
    props: {
      conTypes: { type: Array, required: true },
      type_selectedValues: { type: Array, default: () => [] },
      conTags: { type: Array, required: true },
      tag_selectedValues: { type: Array, default: () => [] },
       conversationTags: { type: Array, default: () => []},
       conversationTag_selectedValues: { type: Array, default: () => [] },
    },
    data() {
      return {
        selectedTypes: this.type_selectedValues,
        selectedTags: this.tag_selectedValues,
      };
    },
    computed:{
      ...mapGetters("window", ["isMobile"]),
      ...mapGetters(["isODEnabled"]),
conversationTagFilter:{
   get(){
     return this.conversationTag_selectedValues;
   },
   set(val){
    this.$emit("conversation-tag-change", val);
   }
 }
    },
    methods: {
      handleSelectTypes(newValues) {
        this.selectedTypes = newValues;
        this.$emit("update:type_selectedValues", this.selectedTypes);
        this.$emit("apply-filter");
      },
      handleSelectTags(newValues) {
        this.selectedTags = newValues;
        this.$emit("update:tag_selectedValues", this.selectedTags);
        this.$emit("apply-filter");
      },
      // for now we select one item at a time, no multiple select

      removeTypeSelectedChip(value) {
        this.selectedTypes = this.selectedTypes.filter((v) => v !== value);
        this.$emit("update:type_selectedValues", this.selectedTypes);
        this.$emit("apply-filter");
      },
      removeTagSelectedChip(value) {
        this.selectedTags = this.selectedTags.filter((v) => v !== value);
        this.$emit("update:tag_selectedValues", this.selectedTags);
        this.$emit("apply-filter");
      },
      //Colse The Filter Component
      closeFilter() {
        this.$emit("closeFilter");
      },
     
    },
  };
  </script>
  
  <style scoped>
  
  </style>